<ng-container [formGroup]="certForm">
    <h4
        mat-dialog-title
        *ngIf="!data.externalPartnerId"
        i18n="@@9242e99a787162f2320f82726f682ed9d6d249a6"
        t="9242e99a787162f2320f82726f682ed9d6d249a6"
        >Add Certification</h4
    >
    <h4
        mat-dialog-title
        *ngIf="data.externalPartnerId"
        i18n="@@116817fbff3e23c14234863af4f666bb5f5c8840"
        t="116817fbff3e23c14234863af4f666bb5f5c8840"
        >Update Certification</h4
    >

    <div class="grid">
        <div fxLayout="row" fxLayoutGap="10px">
            <div fxFlex="55">
                <tsl-form-field fxFlex>
                    <tsl-label
                        i18n="@@1bceea2a2b0db2ba2368ab532988ab5c1ef3b749"
                        t="1bceea2a2b0db2ba2368ab532988ab5c1ef3b749"
                        >What Certification?</tsl-label
                    >
                    <!-- todo ttp -->
                    <input
                        tslInput
                        fullWidth
                        required
                        shape="rectangle"
                        tPlaceholder="2615755136995079045" i18n-placeholder="@@2615755136995079045"
                        placeholder="Certification Type"
                        formControlName="type"
                        [tslAutocomplete]="auto"
                    />
                    <tsl-autocomplete #auto="tslAutocomplete" (optionSelected)="onSelectType($event.option)">
                        <tsl-option *ngFor="let certType of certificationTypes" [value]="certType"
                            >{{ translate.get(certType.type) }}
                        </tsl-option>
                    </tsl-autocomplete>
                    <tsl-error *ngIf="type.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>
            <div fxFlex="45">
                <tsl-form-field fxFlex>
                    <tsl-label
                        i18n="@@600889f42ed29c7e8d6759417e8ec18b9a269f51"
                        t="600889f42ed29c7e8d6759417e8ec18b9a269f51"
                        >When Did You Get Certified?</tsl-label
                    >
                    <tsl-datepicker singleSelection required shape="rectangle" [max]="maxDate" formControlName="issued" [readonly]="true">
                    </tsl-datepicker>
                    <tsl-error *ngIf="issued.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>
        </div>
        <div fxLayout="row" fxLayoutGap="10px">
            <div fxFlex="55">
                <tsl-form-field fxFlex>
                    <tsl-label
                        i18n="@@59d00489a2079a4dd908b127a544d316b6f58a18"
                        t="59d00489a2079a4dd908b127a544d316b6f58a18"
                        >Who Certified It?</tsl-label
                    >
                    <input tslInput fullWidth required maxlength="75" shape="rectangle" formControlName="issuer" />
                    <tsl-error *ngIf="issuer.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>
            <div fxFlex="45">
                <tsl-form-field fxFlex>
                    <tsl-label
                        i18n="@@5c6e62a783d740ae2d640d9c754f84d4f099b6ab"
                        t="5c6e62a783d740ae2d640d9c754f84d4f099b6ab"
                        >When Does The Certificate Expire?</tsl-label
                    >
                    <tsl-datepicker singleSelection shape="rectangle" formControlName="expired" [readonly]="true"> </tsl-datepicker>
                </tsl-form-field>
            </div>
        </div>
        <div fxLayout="row">
            <div fxFlex>
                <div class="upload-bar">
                    <label for="cerFile">
                        <tsl-icon size="small">backup</tsl-icon
                        ><span class="file-input-label" i18n="@@Browse" t="Browse"> Browse</span>
                    </label>
                    <input
                        id="cerFile"
                        class="file-input"
                        type="file"
                        (change)="onAddFile($event.target.files[0])"
                        accept=".doc,.docx,.xls,.xlsx,.pdf,.txt,.ppt,.pptx,.pstx,.jpg,.jpeg,.xps"
                    />
                    <div class="image-list">
                        <ul>
                            <li *ngFor="let file of data.attachments; let i = index">
                                <div
                                    class="file-img {{ getFileType(file.name) }}"
                                    matTooltip="{{ file.name }}"
                                    (click)="onDownloadAttachment(file)"
                                ></div>
                                <tsl-icon size="small" status="error" (click)="onDeleteAttachment(file, i)"
                                    >delete
                                </tsl-icon>
                            </li>
                            <li class="no-saved" *ngFor="let file of data.newFiles">
                                <div
                                    class="file-img {{ getFileType(file.name) }}"
                                    matTooltip="{{ file.name }}"
                                    (click)="onDownloadFile(file)"
                                ></div>
                                <tsl-icon size="small" status="error" (click)="onDeleteFile(file)">delete</tsl-icon>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="right">
        <button tsl-button size="small" color="black" outline (click)="onClose()" i18n="@@Cancel" t="Cancel"
            >Cancel</button
        >
        <button
            tsl-button
            size="small"
            color="blue"
            filled
            [disabled]="certForm.invalid"
            (click)="onSave()"
            i18n="@@Save"
            t="Save"
            >Save</button
        >
    </div>
</ng-container>
